import _ from 'lodash';
import { format } from 'date-fns';
//reducers
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import {
  getNewPay,
  upsertPayBeneficiary,
  getMessage,
  setActiveStep,
  intializePay,
  setMessage,
  getPayFees,
} from 'state/reducers/pay.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { getBeneficiaries, getLoadingBeneficiaries } from 'state/reducers/beneficiary.reducers';
import {  getPaymentDates } from 'services/pay.services';
//components
import { FormsStack } from 'theme/elements/Forms';
import { invalidFields } from 'components/FormCreator/types';
import { validateFields, setListOfInvalids } from 'components/FormCreator/validation';
import WarningDialog from 'components/WarningDialog';
//sections
import BeneficiaryDetailsForm from './BeneficiaryDetailsForm';
import Footer from '../Footer';
//constants
import { paySteps, fieldsValidations, PayEnum, payIntialState } from 'constants/pay.constants';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { pagesEnum, timing, userMessage } from 'constants/ui.constants';
import { Beneficiary } from 'constants/beneficiary.constants';
import { useNavigate, useParams } from 'react-router-dom';
import { getCompanyBalances } from 'state/reducers/balance.reducers';

export default function Step1(props: { handleCancel: any }) {
  const isLoadingBeneficiaries = useAppSelector(getLoadingBeneficiaries);
  const beneficiaries: Beneficiary[] = useAppSelector(getBeneficiaries);
  const userMessage: userMessage = useAppSelector(getMessage);
  const pay = useAppSelector(getNewPay);
  const dispatch = useAppDispatch();
  const t = useAppSelector(selectTranslations);
  const { id } = useParams();
  const [insufficientBalance, setInsufficientBalance] = useState(false);
  const paymentFees = useAppSelector(getPayFees);
  const paymentFeesLoading = useAppSelector((state) => state.pay.paymentFeesLoading);
const paymentFeesError = useAppSelector((state) => state.pay.paymentFeesError);
  const companyBalancesList: any[] = useAppSelector(getCompanyBalances);
  const handleChange = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    const obj = _.groupBy(beneficiaries, 'id');
    if (_.has(obj, value || '')) {
      let bn = _.get(obj, value || '')[0];
      dispatch(
        upsertPayBeneficiary({
          beneficiary: bn,
          [name]: value,
        })
      );
      dispatch(getPaymentDates(bn.currencyId || '', format(new Date(), timing.DATE_FOR_SERVICE)));
    } else {
      dispatch(intializePay({ ...payIntialState, [name]: value }));
    }
    if (_.has(fieldsValidations, name)) {
      setInvalidFields(setListOfInvalids(invalidFields, fieldsValidations, name, value));
    }
  };

  const isValidForm = useMemo(() => {
    let obj = { [PayEnum.beneficiaryId]: pay[PayEnum.beneficiaryId] };
    return validateFields(fieldsValidations, obj);
  }, [pay]);

  const handleSubmit = () => {
    const invalidFields = isValidForm;
    if (!_.keys(invalidFields).length) {
      dispatch(setActiveStep(paySteps.PAYMENT_DETAILS));
    } else {
      setInvalidFields(invalidFields);
    }
  };
  const [invalidFields, setInvalidFields] = useState<invalidFields>({});

  const openDialog = useMemo(() => {
    return userMessage.exist;
  }, [userMessage]);

  useEffect(() => {
    if (id && beneficiaries?.length) {
      const beneficiary = beneficiaries?.filter((beneficiary: any) => beneficiary?.id === parseInt(id))[0];
      const relevantCurrency = companyBalancesList?.filter(
        (balance: any) => balance?.currency?.id === beneficiary?.currencyId
      )[0];
      setInsufficientBalance(relevantCurrency ? relevantCurrency?.amount === 0 : true);
    }
    if (!id) {
      setInsufficientBalance(false);
    }
  }, [id, beneficiaries]);

  return (
    <Fragment>
      <WarningDialog
        open={openDialog}
        title={t(userMessage.text || '')}
        subTitle={userMessage.subText}
        handleCancel={() => {
          dispatch(setMessage({ exist: false }));
        }}
      />
      {isLoadingBeneficiaries && (
        <FormsStack>
          <BeneficiaryDetailsForm
            invalidFields={invalidFields}
            handleChange={handleChange}
            insufficientBalance={insufficientBalance}
          />
          <Footer
            handleCancel={props.handleCancel}
            handleBack={() => { }}
            ifBack={false}
            labelSubmit={t('page.pay.create.step.1.continue_button.text')}
            disableSubmit={
              insufficientBalance ||
              _.keys(isValidForm).length > 0 ||
              paymentFeesLoading ||
              paymentFeesError
            }
            handleSubmit={handleSubmit}
            labelCancel={t('page.pay.create.step.1.cancel_button.text')}
          />
        </FormsStack>
      )}
    </Fragment>
  );
}
